// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__QN0AZ","select":"Header_select__1pE4i","clinic":"Header_clinic__1F57Z"};